// gastosContext.js
import { createContext, useState, useContext, useCallback  } from "react";

import { listarVentasXMetodoUseCase } from "../../../core/facturacion/application/listarVentasXMetodo.useCase.js";

export const VentasxMetodoContext = createContext(null);


export function useVentasxMetodo() {
  const context = useContext(VentasxMetodoContext);
  if (!context) {
    throw new Error(" [useVentasxMetodo]  debe usarse dentro de VentasxMetodoProvider");
  }
  return context;
}

export function VentasxMetodoProvider({ children }) {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  //
const listarVentasMetodo = useCallback(async (filtros) => {
  setLoading(true);
  setError(null);

  try {
    const data = await listarVentasXMetodoUseCase(filtros);
    setVentas(data);
    return data;
  } catch (e) {
    setError(e.message || "Error al listar ventas");
    throw e;
  } finally {
    setLoading(false);
  }
}, []);

  return (
    <VentasxMetodoContext.Provider
      value={{
        ventas,
        loading,
        error,
        listarVentasMetodo,
      }}
    >
      {children}
    </VentasxMetodoContext.Provider>
  );
}


